module.exports = __webpack_public_path__ + "static/media/gold.9f8f0403.png";